import {Base} from "@/api/Base"

export class LogDelete extends Base {
    path = "log/delete"
}